import {
  CONFIRM_BUTTON_DISABLED,
  SET_COMPANY_ATTACHMENTS,
  SET_INDIVIDUAL_ATTACHMENTS,
  SET_INFATH_WORKFLOW_OPEN,
  SET_SELECTED_PARTICIPANT_REVIEW_ELEMENTS,
  SET_SELECTED_TIMED_AUCTION,
  SET_VIEW_REVIEW_STATUS_OPEN,
} from "./types";

const initialState = {
  confirmButtonDisabled: true,
  individualAttachments: {
    iqamaType: "RE", // or "RE_PREMIUM"
    iqamaFile: "",
    innerMunicipalityFile: "",
    noExistingPropertyFile: "",
    otherFiles: [],
  },
  companyAttachments: {
    ownershipType: "SAUDI_OWNED", // or "HAS_FOREIGN_OWNERSHIP"
    commercialRegistrationFile: "",
    investmentLicenseFile: "",
    otherFiles: [],
  },
  isInfathWorkflowOpen: false,
  selectedTimedAuction: null,
  isViewReviewStatusOpen: false,
  selectedParticipantReviewElements: null,
};

const InfathParticipationWorkflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_BUTTON_DISABLED:
      return { ...state, confirmButtonDisabled: action.payload };
    case SET_INDIVIDUAL_ATTACHMENTS:
      return { ...state, individualAttachments: action.payload };
    case SET_COMPANY_ATTACHMENTS:
      return { ...state, companyAttachments: action.payload };
    case SET_INFATH_WORKFLOW_OPEN:
      return { ...state, isInfathWorkflowOpen: action.payload };
    case SET_SELECTED_TIMED_AUCTION:
      return { ...state, selectedTimedAuction: action.payload };
    case SET_VIEW_REVIEW_STATUS_OPEN:
      return { ...state, isViewReviewStatusOpen: action.payload };
    case SET_SELECTED_PARTICIPANT_REVIEW_ELEMENTS:
      return { ...state, selectedParticipantReviewElements: action.payload };
    default:
      return state;
  }
};

export default InfathParticipationWorkflowReducer;
